import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { StateKeys } from "../../redux/states/main.state";
import { RouteComponentProps, useParams } from "react-router";
import {
  AppPageScrollDownLoadMore,
  AppState,
  getContentProviderId,
} from "../../services/app.service";
import Main from "../../redux/actions/main.action";
import ApiEndpoint from "../../services/api.endpoint.service";
import Loader from "../../components/Loader";
import Card from "../../components/Card";
import {
  ClassResponse,
  ContentProviderResponse,
} from "../../services/api.response.service";
import ClassesCardVList from "../../components/ClassesCardVList";
import { RouteEndpoints } from "../../services/route.service";
import NoData from "./NoData";
import Languages from "../../components/Languages";
import { Mixpanel } from "../../services/mixpanel";
import OverviewInfoCard from "../../components/classCourse/OverviewInfoCard";

function ContentProviderDetails({ location }: RouteComponentProps) {
  // const id = location.pathname.replace("/cp/", "");
  let { id } = useParams<{ id: string }>();
  let { link } = useParams<{ link: string }>();
  const dispatch = useDispatch();
  const state = useSelector((state: IRootState) => state.main);

  const details = state[StateKeys.CONTENT_PROVIDER_DETAILS];
  const classes = state[StateKeys.CONTENT_PROVIDER_CLASSES];

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const [mp, setMp] = useState<boolean>(false);
  useEffect(() => {
    if (!mp && (details.data as ContentProviderResponse)?.name) {
      Mixpanel.track("Content Provider Details View", {
        with: currentUser?.id ? "Auth" : "Guest",
        user_id: currentUser?.id,
        content_provider_id: id,
        content_provider_name: (details.data as ContentProviderResponse).name,
      });
      setMp(true);
    }
  }, [details.data]);

  let getCpId = () => {
    let theId = String((details.data as ContentProviderResponse).id);
    if (
      theId &&
      theId !== "" &&
      theId !== undefined &&
      theId !== "undefined" &&
      theId !== null
    ) {
      id = theId;
      // return theId
    }

    // if(id && id !== ""){
    if (
      id &&
      id !== "" &&
      id !== undefined &&
      id !== "undefined" &&
      id !== null
    ) {
      return id;
    }
    // if (link && link !== "") {
    //       return link
    // }
    // return (String((activeClass.data as ClassResponse).id));
    return "";
  };

  useEffect(() => {
    if (
      // details.pageState !== AppState.LOADED ||
      // (details.pageState === AppState.LOADED &&
      //   String((details.data as ContentProviderResponse).id) !== getCpId())
      true
    ) {
      // console.log("get id",getCpId())
      // console.log("cp id",String((details.data as ContentProviderResponse).id))
      // console.log("main id",id)
      // console.log("link",link)

      dispatch(
        Main.getPageObjectData({
          stateKey: StateKeys.CONTENT_PROVIDER_DETAILS,
          apiEndpoint: ApiEndpoint.ACTIVE_CONTENT_PROVIDERS(link ?? id),
        }),
      );
      dispatch(
        Main.postPaginatedPageDataSuccess({
          stateKey: StateKeys.CONTENT_PROVIDER_CLASSES,
          data: [],
          clear: true,
        }),
      );
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.CONTENT_PROVIDER_CLASSES,
          apiEndpoint: ApiEndpoint.CONTENT_PROVIDERS_CLASSES(link ?? id, null),
          previousPage: 0,
        }),
      );
    }
  }, [id]);

  const loadMore = () => {
    // @ts-ignore
    if (
      window.innerHeight + document.documentElement.scrollTop === // @ts-ignore
        document.scrollingElement.scrollHeight &&
      classes.hasMore &&
      (classes.pageState !== AppState.LOADING || // @ts-ignore
        classes.pageState !== AppState.LOADING_MORE)
    ) {
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.CONTENT_PROVIDER_CLASSES,
          apiEndpoint: ApiEndpoint.CONTENT_PROVIDERS_CLASSES(link ?? id, null),
          previousPage: classes.currentPage!,
        }),
      );
    }
  };

  return (
    <div
      className="content-page scroller-hide"
      onScroll={(e) => AppPageScrollDownLoadMore(e, loadMore)}
    >
      <Row>
        {(details.pageState === AppState.LOADED ||
          details.pageState === AppState.LOADING_MORE) && (
          <>
            {!details.data && (
              <NoData
                title="noContentProviderFound"
                link={RouteEndpoints.CONTENT_PROVIDERS}
                btnText="backToContent"
              />
            )}

            {details.data && (
              <>
                <OverviewInfoCard data={details.data} />
                <div className="content-card">
                  <ClassesCardVList
                    data={classes.data as Array<ClassResponse>}
                    state={classes.pageState}
                    title="classes"
                  />

                  <Col md={12}>
                    {classes.hasMore &&
                      !(
                        classes.pageState === AppState.LOADING ||
                        classes.pageState === AppState.LOADING_MORE
                      ) && (
                        <div
                          className={`w-100 text-center shadow-xss rounded-xxl border-0 px-3`}
                        >
                          <button
                            className="text-decoration-none btn btn-primary"
                            onClick={() => loadMore()}
                          >
                            <Languages langKey="loadMore" />
                          </button>
                        </div>
                      )}
                  </Col>
                  <Col md={12}>
                    {(classes.pageState === AppState.LOADING_MORE ||
                      classes.pageState === AppState.LOADING) && (
                      <Loader noCard imageLoader />
                    )}
                  </Col>
                </div>
              </>
            )}
          </>
        )}
        {details.pageState === AppState.ERROR_404 && (
          <NoData
            title="noContentProviderFound"
            link={RouteEndpoints.CONTENT_PROVIDERS}
            btnText="backToContent"
          />
        )}
      </Row>
    </div>
  );
}

export default ContentProviderDetails;
